import { c as _c } from "react/compiler-runtime";
import { Link as MuiLink } from '@mui/material';
import type * as v from 'valibot';
import type { StructuredContentDocument } from '../../hydration/types';
import type { creditCardsOfferRatesAndFeesLinkSchema } from './schema';
export function CreditCardsOfferRatesAndFeesLink(t0) {
  const $ = _c(9);
  const {
    props: t1
  } = t0;
  const {
    marketplaceEntityV2
  } = t1;
  if (!marketplaceEntityV2.termsAndFeesLink) {
    return null;
  }
  let T0;
  let t2;
  let t3;
  if ($[0] !== marketplaceEntityV2.cta.type || $[1] !== marketplaceEntityV2.termsAndFeesLink) {
    const url = new URL(marketplaceEntityV2.termsAndFeesLink);
    url.searchParams.set("finish_type", "external_application");
    url.searchParams.set("cta_type", marketplaceEntityV2.cta.type);
    T0 = MuiLink;
    t2 = "hover";
    t3 = url.toString();
    $[0] = marketplaceEntityV2.cta.type;
    $[1] = marketplaceEntityV2.termsAndFeesLink;
    $[2] = T0;
    $[3] = t2;
    $[4] = t3;
  } else {
    T0 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== T0 || $[6] !== t2 || $[7] !== t3) {
    t4 = <T0 underline={t2} href={t3} rel="nofollow">rates and fees</T0>;
    $[5] = T0;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export type CreditCardsOfferRatesAndFeesLinkProps = StructuredContentDocument<v.InferInput<typeof creditCardsOfferRatesAndFeesLinkSchema>>;